import React from 'react';
import { Box, Typography } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
 
// Renders nothing if the OAuth client isn't configured yet, instead of crashing
// (GoogleLogin requires a GoogleOAuthProvider ancestor, which index.js only mounts
// when REACT_APP_WEB_CLIENT_ID is set).
export default function GoogleAuthButton({ onSuccess, onError, label }) {
  const isConfigured = Boolean(process.env.REACT_APP_WEB_CLIENT_ID);
  if (!isConfigured) return null;
 
  return (
    <Box
      className="logoSection"
      sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}
    >
      {label && (
        <Typography className="textLabel" marginBottom={0}>
          <span>{label}</span>
        </Typography>
      )}
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <GoogleLogin
          onSuccess={onSuccess}
          onError={onError}
          shape="pill"
          width="320"
          text="continue_with"
        />
      </Box>
    </Box>
  );
}
 
 